import React from 'react';

import { useCurrentUser } from 'Auth';

import {
  Button,
  Link,
  Typography,
  Stack,
  makeStyles,
  OpenInNewIcon,
  LockPersonIcon,
  LockIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

const useStyles = makeStyles(
  () => ({
    root: {
      flexGrow: 1,
    },
  }),
  { name: 'AccessDenied' }
);

export const AccessDenied = () => {
  const blocked = useCurrentUser()?.isBlocked;
  const classes = useStyles();

  return (
    <Stack
      spacing={3}
      alignItems={'center'}
      justifyContent={'center'}
      className={classes.root}
    >
      {blocked ? (
        <LockPersonIcon sx={{ fontSize: 64 }} color={'action'} />
      ) : (
        <LockIcon sx={{ fontSize: 64 }} color={'action'} />
      )}
      <Stack spacing={2}>
        {blocked ? (
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Typography variant={'subtitle1'}>
              Looks like your account might be taking a little nap due to
              inactivity.
            </Typography>
            <Typography variant={'subtitle1'}>
              No worries, though! Just send a re-activation request, and we'll
              happily help you wake it up by reactivating your account.
            </Typography>
          </Stack>
        ) : (
          <Typography variant={'subtitle1'}>
            You need access to this page. Would you like to send a permission
            request?
          </Typography>
        )}
        <Stack alignItems={'center'}>
          <Link
            href={
              'https://go-game.zendesk.com/auth/v2/login/signin?return_to=https%3A%2F%2Fgo-game.zendesk.com%2Fhc%2Fen-us%2Frequests%2Fnew&theme=hc&locale=en-us&brand_id=360001170173&auth_origin=360001170173%2Cfalse%2Ctrue'
            }
            target={'_blank'}
          >
            <Button variant={'outlined'} icon={<OpenInNewIcon />}>
              request access
            </Button>
          </Link>
        </Stack>
      </Stack>
    </Stack>
  );
};

export const AccessDeniedWithRedirect = ({ redirectTo = '/v3', ...props }) => {
  const [childComponent] = useChildComponent(AccessDenied, {
    redirectTo,
    ...props,
  });

  return childComponent;
};
